<div class="spinner">
	<div class="spinner__circle"></div>
</div>
